module.exports = __webpack_public_path__ + "static/media/fin_cord.df393efe.jpg";